import { uniqueId } from 'lodash';
import React from 'react';

import { useSiteLang } from '../../../hooks/useCKReducer';
import { usePageContext } from '../../../providers/PageContext';
import ContactForm from './ContactForm';
import { translateTo } from './contactForm.util';
import translations from './translations.json';

const ContactFormWrapper: React.FunctionComponent<any> = ({ textColor }) => {
  const context = usePageContext();
  const { siteLang } = useSiteLang();
  const [state, setState] = React.useState({
    firstName: '',
    lastName: '',
    phone: '',
    company: '',
    email: '',
    orders: '',
    locations: '',
  });

  const stateHandler = (newState: Partial<typeof state>) =>
    setState((prevState) => ({ ...prevState, ...newState }));

  const parentId = uniqueId('contact-form-parent-');
  const prefixId = uniqueId('contact-form-prefix-');
  const { siteTag, countryCode } = context;
  const langKey = siteLang.split('-')[0];

  const translate = translateTo({
    lang: langKey,
    translations,
    defaultLang: 'en',
  });

  const backwardsCompatibleSiteTag = siteTag.split(':')[1];

  return (
    <div id={parentId}>
      <ContactForm
        parentId={`#${parentId}`}
        prefixId={prefixId}
        stateHandler={stateHandler}
        langKey={langKey}
        siteTag={backwardsCompatibleSiteTag}
        translate={translate}
        countryCode={countryCode}
        color={textColor}
        {...state}
      />
    </div>
  );
};

export default ContactFormWrapper;
